export default {
  SET_WALLET_SUMMARY: (state, wallet_summary) => (state.wallet_summary = wallet_summary),
  SET_SHIPMENTS: (state, shipments) => (state.shipments = shipments),
  SET_SHIPMENTS_PAGINATION: (state, shipments_pagination) => (state.shipments_pagination = shipments_pagination),
  SET_SHIPMENT_DETAIL: (state, shipment_detail) => (state.shipment_detail = shipment_detail),
  SET_WALLET_MOVEMENTS: (state, wallet_movements) => (state.wallet_movements = wallet_movements),
  SET_WALLET_MOVEMENTS_PAGINATION: (state, wallet_movements_pagination) => (state.wallet_movements_pagination = wallet_movements_pagination),
  SET_ERROR_MSG: (state, error_msg) => (state.error_msg = error_msg),
};
